<template>
  <div class="customer-case view-conten">
    <!-- banner区域 -->
    <div class="customer-case-banner">
      <div class="banner-title">
        <div class="banner-title-cn">客户案例</div>
        <div class="banner-title-en">Customer Case</div>
        <div class="banner-line"></div>
      </div>
      <img src="@/assets/customerCase/banner-bg.jpg" alt="" />
    </div>
    <!-- 内容卡片区域 -->
    <div class="customer-case-content">
      <!-- 案例介绍 -->
      <div class="customer-card-wrap">
        <div class="customer-card-item">
          <img class="card-img" src="@/assets/customerCase/case1.jpg" alt="" />
          <div class="card-info">
            <div class="card-info-title">万向钱潮</div>
            <div class="card-info-content">
              1994年万向钱潮（000559）在深交所上市交易；万向钱潮一直致力于汽车零部件的研发和制造，产品从零件到部件到系统集成，生产专业化，产品系列化，供货模块化；产品涵盖万向节、轮毂单元、轴承、汽车底盘及悬架系统、制动系统、传动系统、排气系统、燃油箱、工程机械零部件等汽车系统零部件及总成，是国内最大的独立汽车系统零部件供应商之一。
            </div>
          </div>
        </div>
        <div class="customer-card-item">
          <img class="card-img" src="@/assets/customerCase/case2.jpg" alt="" />
          <div class="card-info">
            <div class="card-info-title">中广电器</div>
            <div class="card-info-content">
              浙江中广电器股份有限公司是一家以空气能技术为核心，集中央地暖、中央空调、中央热水、中央净水、中央新风等产品研发、生产、销售、服务于一体的国家高新技术企业。拥有囯际一流的生产流水线及国内领先的CNAS智能实验室群，是目前亚洲规模一流的舒适家居系统和商用暖通热水综合解决方案供应商。
            </div>
          </div>
        </div>
        <div class="customer-card-item">
          <img class="card-img" src="@/assets/customerCase/case3.jpg" alt="" />
          <div class="card-info">
            <div class="card-info-title">LUCECO</div>
            <div class="card-info-content">
              LUCECO集团（纯英资），是一家高品质创新LED照明、墙面开关插座和便携式电源等产品的国际制造商和经销商。
              LUCECO集团在欧洲已拥有100余年的发展历史。迄今为止，LUCECO集团已成功打造了LUCECO（LED照明）、BRITISH
              GENERAL（墙面开关及插座）、MASTERPLUG（便携式电源）、ROSS
              ELECTRICAL（电视机支架）、KINGFISHER（室外照明和配件）五大充满活力的自主品牌。
            </div>
          </div>
        </div>
        <div class="customer-card-item">
          <img class="card-img" src="@/assets/customerCase/case4.png" alt="" />
          <div class="card-info">
            <div class="card-info-title">民生人寿保险股份有限公司</div>
            <div class="card-info-content">
              民生人寿保险股份有限公司，于2003年6月18日正式开业，注册资本金60亿元，总部位于上海，建立了覆盖全国重点省市区域的机构服务网络，拥有26家分公司、超500个服务网点、近1.5万名高素质专业人员，累计服务用户超1067万。截至2024年底，公司综合实力稳步提升，实现原保险保费收入128.87亿元，总资产1404.79亿元，累计十四年盈利；偿付能力充足稳定，风险综合评级四个季度均维持在BBB级。
            </div>
          </div>
        </div>
      </div>
      <!-- 轮播 -->
      <div class="customer-card-swiper">
        <swiper class="swiper-container" :options="swiperOption" ref="mySwiper">
          <swiper-slide style="width: 100%" v-for="(items, index) in swiperData" :key="index">
            <div class="swiper-item">
              <el-row :gutter="10" v-for="(item, itemi) in items" :key="itemi">
                <el-col style="width: 20%;" v-for="(el, ei) in item" :key="ei">
                  <div style="border: 1px solid #ddd; padding: 10px;">
                    <img width="100%" height="92px" :src="el" alt="" />
                  </div>
                </el-col>
              </el-row>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        autoplay: true, // 自动轮播
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperData: [
        // 第一块轮播
        [
          // 第一行数据
          [
            require('@/assets/company/logo-wanxiang.png'),
            require('@/assets/company/logo-zgdq.svg'),
            require('@/assets/company/logo-luceco.svg'),
            require('@/assets/company/logo-contigon.svg'),
            require('@/assets/company/logo-emc.svg')
          ],
          // 第二行数据
          [
            require('@/assets/company/logo-aopu.svg'),
            require('@/assets/company/logo-keb.svg'),
            require('@/assets/company/logo-dajin.jpg'),
            require('@/assets/company/logo-zxq.jpg'),
            require('@/assets/company/logo-a123.jpg')
          ]
        ],
        // 第二块轮播
        [
          // 第一行数据
          [
            require('@/assets/company/logo-hasco.jpg'),
            require('@/assets/company/logo-ms.png'),
            require('@/assets/company/logo-yl.png'),
            require('@/assets/company/logo-innomotics.svg'),
            require('@/assets/company/logo-hljh.png')
          ],
          // 第二行数据
          [

            require('@/assets/company/logo-guomao.jpg'),
            require('@/assets/company/logo-anran.jpg'),
            require('@/assets/company/logo-dzpng.png'),
            require('@/assets/company/logo-yxtg.jpg'),
            require('@/assets/company/logo-sfm.jpg')
          ]
        ]
      ]
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.customer-case {
  width: 100%;

  .customer-case-banner {
    position: relative;

    .banner-title {
      color: #ffffff;
      position: absolute;
      width: 1200px;
      margin: 0 auto;
      top: 121px;
      left: 0;
      right: 0;

      .banner-title-cn {
        font-size: 48px;
        font-weight: bold;
      }

      .banner-title-en {
        margin-top: 10px;
        font-size: 24px;
        padding-bottom: 13px;
        // border-bottom: 10px solid #0990FF;
      }

      .banner-line {
        width: 114px;
        height: 10px;
        background: #0990ff;
      }
    }

    img {
      width: 100%;
      height: 400px;
    }
  }

  .customer-case-content {
    .customer-card-wrap {
      padding-top: 50px;
      margin: 0 auto;
      width: 1200px;

      .customer-card-item {
        margin-top: 50px;
        width: 100%;
        background-color: #f8f8f8;
        height: 360px;
        display: flex;

        .card-img {
          // width: 600px;
          min-width: 600px;
          height: 100%;
        }

        .card-info {
          padding-top: 50px;
          padding-left: 40px;
          padding-right: 40px;

          .card-info-title {
            font-size: 28px;
            color: #333333;
            margin-bottom: 24px;
            font-weight: bold;
          }

          .card-info-content {
            font-size: 16px;
            color: #333333;
            line-height: 32px;
          }
        }
      }
    }
  }

  .customer-card-swiper {
    margin: 0 auto;
    width: 1200px;

    .swiper-container {
      --swiper-theme-color: #ff6600;
      /* 设置Swiper风格 */
      --swiper-navigation-color: #666666;
      /* 单独设置按钮颜色 */
      --swiper-navigation-size: 34px;

      /* 设置按钮大小 默认是44px */
      .swiper-item {

        // padding-top: 72px;
        // padding-bottom: 72px;
        .el-row {
          &:last-child {
            margin-top: 10px;
          }
        }

        padding: 72px 60px;

        img {
          max-width: 269px;
          object-fit: contain;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/customerCase.vue